module.exports = __webpack_public_path__ + "621235645b27fcc5380b0dfabfa0fc63.pdf";